import { render, staticRenderFns } from "./VipConfig.vue?vue&type=template&id=0f25c37c&"
import script from "./VipConfig.vue?vue&type=script&lang=js&"
export * from "./VipConfig.vue?vue&type=script&lang=js&"
import style0 from "./VipConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports